import { useState } from "react";
import { IconButton, Tooltip } from "@mui/material";
import { History } from "@mui/icons-material";
import { intl } from "LocaleWrapper";
import EntityHistoryDialog, {
	EntityHistoryDialogProps,
} from "components/entityHistory/components/dialogs/EntityHistoryDialog";

const EntityHistoryButton = (props: Omit<EntityHistoryDialogProps, "open" | "onClose" | "title">) => {
	const [ dialogOpen, setDialogOpen ] = useState(false);

	return <>
		<Tooltip title={intl.formatMessage({ id: "HISTORY" })}>
			<IconButton
				size="small"
				onClick={() => setDialogOpen(true)}
			>
				<History fontSize="small" />
			</IconButton>
		</Tooltip>

		{dialogOpen && (
			<EntityHistoryDialog
				open={dialogOpen}
				onClose={() => setDialogOpen(false)}
				title={intl.formatMessage({ id: "HISTORY" })}
				{...props}
			/>
		)}
	</>;
};

export default EntityHistoryButton;
